/*
import Vue from 'vue'
import App from './App.vue'

new Vue({
  el: '#app',
  render: h => h(App)
})
*/
import Vue from 'vue'
import App from './App.vue'
import store from './_store'

Vue.use(require('vue-shortkey'))

new Vue({
  el: 'app',
  store,
  components: {
    local:App
  },
  template: '<main><local :refugio="refugio" :idioma="i18n" /></main>',
  data: {
    refugio:0,
    i18n:'es',
    gr11:false
  },
  beforeMount: function () {
    this.refugio = (this.$el.attributes['refugio'].value.includes(','))
      ? this.$el.attributes['refugio'].value.split(',') : this.$el.attributes['refugio'].value;
    if(this.$el.attributes['idioma'])
      this.i18n = this.$el.attributes['idioma'].value;
    if(this.$el.attributes['gr11'])
      this.gr11 = this.$el.attributes['gr11'].value;
  }
});



// WEBPACK FOOTER //
// ./src/main.js